<template>
  <footer class="footer is-font-3">
    <div class="content-width footer-inner">
      <div class="footer-content">
        <p>
          This webpage and the insurance quote system is independently owned and operated by insurance comparison experts, Seopa Ltd who are authorised and regulated by the Financial Conduct Authority (FCA). Quotezone is a trading style of Seopa Ltd. By using this system, you are agreeing to our
          <a
            :href="`https://www.quotezone.co.uk/legal?${constants.GA_QUOTEZONE_QUERY}`"
            target="_blank"
          >Terms and Conditions</a>
          and
          <a
            :href="`https://www.quotezone.co.uk/privacy-policy?${constants.GA_QUOTEZONE_QUERY}`"
            target="_blank"
          >Privacy Policy</a>.
          You can check this out on the financial services register at <a
            href="https://register.fca.org.uk/"
            target="_blank"
          >https://register.fca.org.uk/</a>. Our register number is 313860. Seopa Ltd is located at {{ constants.SEOPA_LTD_ADDRESS }}.
        </p>
        <p><template v-if="config.fullName">{{ config.partnerFullName }} t/a </template>{{ config.partnerText }} is an Introducer Appointed Representative (IAR) of Seopa Ltd.</p>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'partner-footer',
  inject: ['config', 'constants'],
};
</script>

<style lang="scss" scoped src="@/assets/scss/footer/core-footer-partners.scss"/>
<style lang="scss" scoped src="@/assets/scss/footer/footer-partners.scss"/>
